import { render, staticRenderFns } from "./IroCell.vue?vue&type=template&id=883180e6"
import script from "./IroCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./IroCell.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxLinkIro: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/link/iro.vue').default})
